import { Search } from 'lucide-react'
import { Line } from 'react-chartjs-2'
import { shallow } from 'zustand/shallow'

import { SelectFormComponent } from '@/modules/shared/components/select-form.component'
import { Button } from '@/modules/shared/components/ui/button'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/modules/shared/components/ui/card'
import { Form } from '@/modules/shared/components/ui/form'

import { CardReportSales } from '../components/card-report-sales.component'
import { CardReportTarget } from '../components/card-report-target.component'
import { useChartSalesDialyReport } from '../hooks/use-chart-sales-dialy-report.hook'
import { useChartSalesMonthReport } from '../hooks/use-chart-sales-month-report.hook'
import { useFormSearchReport } from '../hooks/use-form-search-report.hook'
import { useReportStore } from '../useReportsStore'
import type { SearchFormData } from './manage-sellers.interfaces'

export function SalesGoalInterface() {
  const { loading, jsonSalesGoal } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesGoal: state.jsonSalesGoal,
    }),
    shallow,
  )

  const { months, form, handleSearch, getYears } = useFormSearchReport()

  const { chartData: dialyChartData } = useChartSalesDialyReport()
  const { chartData: monthChatData } = useChartSalesMonthReport()

  return (
    <div>
      <div className="flex bg-white p-2 rounded-md space-x-2">
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(handleSearch)}
            className="flex items-end space-x-2 flex-1"
          >
            <SelectFormComponent<SearchFormData>
              control={form.control}
              name="month"
              label="Mês"
              options={months.map((item) => ({
                label: item.name,
                value: item.id.toString(),
              }))}
            />

            <SelectFormComponent<SearchFormData>
              control={form.control}
              name="year"
              label="Ano"
              options={getYears().map((item) => ({
                label: item.toString(),
                value: item.toString(),
              }))}
            />

            <Button type="submit" variant="outline">
              <Search size={20} />
            </Button>
          </form>
        </Form>
      </div>

      {!loading && !!jsonSalesGoal && (
        <div className="space-y-2 mt-2 ">
          <Card>
            <CardContent className="flex-1 flex items-center justify-center p-2 space-x-2">
              <CardReportSales />

              <CardReportTarget />
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Gráfico Diário</CardTitle>
            </CardHeader>
            <CardContent>
              <Line
                data={dialyChartData}
                options={{
                  plugins: {
                    datalabels: {
                      display: false,
                    },
                  },
                }}
              />
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="text-lg">Gráfico Mensal</CardTitle>
            </CardHeader>
            <CardContent>
              <Line
                data={monthChatData}
                options={{
                  plugins: {
                    datalabels: {
                      display: false,
                    },
                  },
                }}
              />
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  )
}
